import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=fc8bb1c8&"
import script from "./Asset.vue?vue&type=script&lang=ts&"
export * from "./Asset.vue?vue&type=script&lang=ts&"
import style0 from "./Asset.vue?vue&type=style&index=0&id=fc8bb1c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports